import React, { FC, useMemo, useState } from 'react'
import Modal from '../common/Modal'
import { labelColor } from '../../../utils/taskStatusLabel'
import { format } from '../../../utils/date'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface UpdateParam {
  comment: string
  target_date_list: string[]
}

interface Props {
  targetDateList: string[]
  closeCallback: VoidFunction
  updateCallback: (param: UpdateParam, callback: VoidFunction) => void
  isDisplay: boolean
  closeable?: boolean
  isApplication?: boolean
}

const MultiApprovedModal: FC<Props> = (props) => {
  const {
    targetDateList,
    closeCallback,
    updateCallback,
    isDisplay,
    closeable,
    isApplication,
  } = props

  const [comment, setComment] = useState<string>("")
  const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false)

  const displayWord = useMemo(() => {
    if (isApplication) return { text: "申請", status: "processing" }
    return { text: "承認", status: "approved" }
  }, [isApplication])

  const closeModal = () => {
    closeCallback()
    setComment("")
  }

  const submitApproval = () => {
    setIsSubmitLoading(true)
    const param = {
      comment: comment,
      target_date_list: targetDateList,
    }
    updateCallback(
      param,
      () => {
        setIsSubmitLoading(false)
        closeModal()
      },
    )
  }

  return (
    <Modal
      show={isDisplay}
      wrapperClass="multi_approved_modal w750"
      closeCallback={closeModal}
      closeable={closeable && !isSubmitLoading}
    >
      <>
        <div className="multi_approved_modal_title">
          {`まとめて${displayWord.text}`}
        </div>
        <div className="multi_approved_modal_main">
          <div className="description">
            {`対象日の仕分けをまとめて${displayWord.text}します`}
          </div>
          <div className="target_display_area">
            <div className="target_display_area_title">
              対象日
            </div>
            <div className="target_display_area_main">
              {
                targetDateList.map((v) => (
                  <div className="date">
                    {format(v, "YYYY年M月D日")}
                  </div>
                ))
              }
            </div>
          </div>
          <div
            className="application_area_title"
            style={{
              backgroundColor: labelColor(displayWord.status),
            }}
          >
            コメント
          </div>
          <textarea
            placeholder="自由入力欄"
            className="application_area_text"
            onBlur={(e) => setComment(e.target.value)}
          />
          <div className="button_area">
            <button
              type="button"
              onClick={closeModal}
              disabled={isSubmitLoading}
            >
              キャンセル
            </button>
            <button
              type="button"
              style={{
                border: `solid 1px ${labelColor(displayWord.status)}`,
                backgroundColor: labelColor(displayWord.status),
                color: "#FFFFFF",
              }}
              onClick={() => submitApproval()}
              disabled={isSubmitLoading}
            >
              {
                isSubmitLoading ? (
                  <>
                    <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                  </>
                ) : (
                  <>
                    {displayWord.text}
                  </>
                )
              }
            </button>
          </div>
        </div>
      </>
    </Modal>
  )
}

MultiApprovedModal.defaultProps = {
  closeable: true,
  isApplication: false,
}

export default MultiApprovedModal
